module.exports = __webpack_public_path__ + "img/three2Orange.e0a78900.jpg";